import { ApiService } from '@b2b/common/services/api/types';
import { PermissionsService } from '@b2b/common/services/permissions';
import { ValidateService } from '@b2b/common/services/validate';
import { TODO, UIBModalService } from '@b2b/types/core';
import { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IScope, ITimeoutService } from 'angular';
import { FormsModalsRemoveControllerModule } from '../../modals/remove/controllers/FormsModalsRemoveController';

export const FormsListControllerModule = angular
  .module('acme.view.application.forms.list.controllers', [
    'ui.router',
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.validate',
    'acme.common.service.permissions',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    FormsModalsRemoveControllerModule,
  ])
  .controller('FormsListController', [
    '$scope',
    '$state',
    '$timeout',
    '$uibModal',
    '$filter',
    'HelpersService',
    'ApiService',
    'ValidateService',
    'PermissionsService',
    'GridStateFactory',
    'GridDefinitionFactory',
    function FormsListController(
      $scope: IScope & { formsList: TODO },
      $state: StateService,
      $timeout: ITimeoutService,
      $uibModal: UIBModalService,
      $filter: IFilterService,
      HelpersService: TODO,
      ApiService: ApiService,
      ValidateService: ValidateService,
      PermissionsService: PermissionsService,
      GridStateFactory: TODO,
      GridDefinitionFactory: TODO
    ) {
      $scope.formsList = {
        model: [],

        gridState: new GridStateFactory(),
        gridDefinition: new GridDefinitionFactory(),

        lastSearchQuery: '',
        searchQuery: '',

        isSearching: false,

        viewId: '',
        formsListGridName: $state.current.name + '.grid0',

        optionsOverride: {
          enableGridMenu: false,
          data: 'formsList.model',
          appScopeProvider: {
            onDataGridPaginate: function (newPageNumber, newPageSize, sortField, sortDirection) {
              $scope.formsList.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
            },
            onDataGridSortChange: function (grid, columns) {
              $scope.formsList.onDataGridSortChange(grid, columns);
            },

            onDblClick: function (item) {
              $scope.formsList.onDblClick(item);
            },

            makeCopy: function (item) {
              $scope.formsList.makeCopy(item);
            },

            remove: function (item) {
              $scope.formsList.remove(item);
            },

            showEvent: function (item) {
              $scope.formsList.showEvent(item);
            },
          },
          columnDefs: [
            {
              field: 'id',
              displayName: 'Id',
              visible: false,
            },
            {
              field: 'name',
              displayName: 'Name',
              sort: {
                direction: 'asc',
              },
            },
            {
              field: 'oncePerCart',
              displayName: 'Once Per Cart',
              cellTemplate: '<div class="ui-grid-cell-contents">{{ (row.entity.oncePerCart) ? "Yes" : "No" }}</div>',
            },
            {
              field: 'status',
              displayName: 'Status',
            },
            {
              field: 'formCategoryType',
              displayName: 'Type',
              cellTemplate:
                '<div class="ui-grid-cell-contents"><span class="text-capitalize">{{ row.entity.formCategoryType}}</span></div>',
            },
          ],
        },

        init: function () {
          this.viewId = $state.current.name;

          if (PermissionsService.check('FORMS_UPDATE')) {
            this.optionsOverride.columnDefs.unshift({
              field: 'edit',
              displayName: 'Edit',
              enableSorting: false,
              onCellNavClick: function (row, col) {
                $scope.formsList.onDblClick(row);
              },
              cellTemplate:
                '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.onDblClick(row)" role="link">Edit<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>',
              enableHiding: false,
              width: 80,
            });
          }
          if (PermissionsService.check('FORMS_DELETE')) {
            this.optionsOverride.columnDefs.push({
              field: 'copy',
              displayName: 'Duplicate',
              enableSorting: false,
              onCellNavClick: function (row, col) {
                $scope.formsList.makeCopy(row);
              },
              cellTemplate:
                '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.makeCopy(row)" role="link">Duplicate<span class="sr-only"> Make copy of {{ row.entity.name }}</span></a></div>',
              enableHiding: false,
              width: 100,
            });
            this.optionsOverride.columnDefs.push({
              field: 'remove',
              displayName: 'Remove',
              onCellNavClick: function (row, col) {
                $scope.formsList.remove(row.entity);
              },
              cellTemplate:
                '<div class="ui-grid-cell-contents" data-ng-if="!row.entity.lastPublishedDate"><a data-ng-click="grid.appScope.remove(row.entity)" role="button">Remove<span class="sr-only">-Opens a dialog</span></a></div>',
              width: 70,
              enableHiding: false,
              enableSorting: false,
              visible: true,
            });
          }

          this.gridDefinition.init(
            this.formsListGridName,
            this.optionsOverride,
            this.viewId,
            $state.current.data.enablePreferences
          );

          $scope.$emit('Application::contentTitleChange', {
            title: 'Forms',
            buttonRight: {
              label: '+ Create Form',
              permissions: 'FORMS_CREATE',
              action: function () {
                $scope.formsList.create();
              },
            },
          });

          $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);
        },

        getForms: function () {
          const props = this.gridState.getGridState();
          props.published = '0';
          ApiService.form.list(props).then(this.success.init, this.error.init);
        },

        initData: function () {
          const self = $scope.formsList;
          const props = self.gridDefinition.getGridState();
          self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
          self.getForms();
        },

        query: function () {
          if (this.searchQuery !== this.lastSearchQuery) {
            this.isSearching = true;
            this.gridState.setPropertyValue('search', this.searchQuery);
            this.lastSearchQuery = this.searchQuery;
            $scope.$broadcast('DataGrid::Search', { name: this.formsListGridName });
          }
        },

        create: function () {
          // TODO: Add create modal here
          $state.go('application.forms.create');
        },

        remove: function (item) {
          const self = $scope.formsList;

          self.removeModal = $uibModal.open({
            templateUrl: 'views/application/views/forms/modals/remove/remove.tpl.html',
            size: 'md',
            controller: 'FormsModalsRemoveController',
            resolve: {
              item: item,
              events: function () {
                return {
                  data: {
                    payload: [],
                  },
                };
              },
              allow: !item.assigned,
            },
          });

          // Invoked when modal completes with close(params)
          self.removeModal.result.then(
            function () {
              ApiService.form.remove(item.id).then(function () {
                self.getForms();
              });
            },
            function () {
              // Do nothing
            }
          );
        },

        showEvent: function (item) {
          $state.go('application.programsInstance', { id: item.eventId });
        },

        makeCopy: function (item) {
          $state.go('application.forms.copy', { copy: item.entity });
        },

        process: function (list) {
          for (let i = 0, ii = list.length; i < ii; i++) {
            if (list[i].lastPublishedDate) {
              list[i].status = 'Published';
            } else {
              list[i].status = 'Draft';
            }
          }

          return list;
        },

        success: {
          init: function (response) {
            const self = $scope.formsList;
            self.model = self.process(response.data.payload.list);
            self.isSearching = false;
            self.gridDefinition.isLoaded = true;
            $timeout(function () {
              $scope.$broadcast('DataGrid::ResizeGrid', {
                name: self.gridDefinition.options.gridName,
                datasetLength: self.model.length,
                totalItems: response.data.payload.pagination.count,
              });
            }, 10);
          },
        },

        error: {
          init: function (response) {
            const self = $scope.formsList;
            self.isSearching = false;
            self.gridDefinition.isLoaded = true;
          },
        },

        onDblClick: function (item) {
          $state.go('application.forms.edit', { formId: item.entity.id });
        },

        onDataGridPaginate: function (newPageNumber, newPageSize, sortField, sortDirection) {
          const self = $scope.formsList;
          const data = {
            currentPage: newPageNumber || 1,
            pageSize: newPageSize || this.gridDefinition.options.paginationPageSize,
          };

          self.gridState.updateGridState(data.currentPage, data.pageSize);
          if (sortField) {
            self.gridState.updateGridState(null, null, sortField, null);
          }
          if (sortDirection) {
            self.gridState.updateGridState(null, null, null, sortDirection);
          }

          self.getForms();
        },

        onDataGridSortChange: function (grid, columns) {
          const self = $scope.formsList;
          const data = columns[0];

          if (data) {
            self.gridState.updateGridState(null, null, data.field, data.sort.direction);

            self.getForms();
          }
        },
      };

      $scope.formsList.init();
    },
  ]).name;
